import React from 'react'
import {ReportEntryCard, RPCDocs, useReportEntries} from '@therms/react-modules'
import {Loading} from '@therms/atalaya'
import {SingleEntryDisplay} from './SingleEntryDisplay'
import Sort = RPCDocs.Reports.GetReportEntryList.v2.Sort

interface ReportInfoProps {
  report: RPCDocs.Reports.GetReport.v1.Report
  reportType: RPCDocs.Reports.GetReport.v1.ReportTypeType
}

function ReportInfo({report, reportType}: ReportInfoProps) {
  // when the Report is "open" then show most recent at the top
  const {data, loading} = useReportEntries({
    reportId: report.id,
    sort: ['timestamp', Sort.Asc],
  })

  if (reportType.inputConfig.type === 'single-entry') {
    if (!data?.entries?.length && loading) return <Loading overlay />

    if (!reportType.inputConfig.entryTypeIds[0]) {
      return (
        <div className="text-color-critical text-center">
          Report Type is mis-configured, no Form Builder information found
        </div>
      )
    }

    if (data?.entries?.length) {
      return (
        <SingleEntryDisplay
          entryId={data?.entries[0]?.id}
          reportId={report.id}
        />
      )
    }

    // this is the case when the current User does not have permission to edit and there is no entry to display
    return (
      <div className="p-xl text-color-neutral text-center">
        <em>No information to display</em>
      </div>
    )
  }

  return (
    <div className="relative">
      {loading && !data && <Loading overlay />}

      {data?.entries?.map((entry) => (
        <ReportEntryCard entry={entry} key={entry.id} />
      ))}
    </div>
  )
}

export {ReportInfo}
